<div tabindex="0" #elementToFocus class="cmv-modal-outer-card logout-mobile">
  <div class="cmv-modal-inner-card cmv-modal-remove">
    <cmv-modal-close-button
      (click)="closeModal(false)"
    ></cmv-modal-close-button>

    <div class="main-info">
      <div class="cmv-h1">
        {{ 'components.modals.cookiesModal.title' | translate }}
      </div>
      <div class="cmv-body cookie-subtitle">
        {{ 'components.modals.cookiesModal.textBefore' | translate }}
        <a href="/privacy" target="_blank" class="cookie-link">
          {{ 'components.modals.cookiesModal.textLink' | translate }}
        </a>
        {{ 'components.modals.cookiesModal.textAfter' | translate }}
      </div>
    </div>
    <cmv-modal-buttons
      acceptLabel="basic.accept"
      declineLabel="basic.decline"
      (accepted)="closeModal(true)"
      (declined)="closeModal(false)"
    ></cmv-modal-buttons>
  </div>
</div>
